import React, { useState, useEffect } from "react";
import reviewsImg from "../../common/Images/reviews.png";
import TruncateComponent from "../../components/TruncateComponent";
import Carousel from "react-multi-carousel";
import { request } from '../../services/BackendService';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

const ReviewsComponent = () => {
  const [reviews, setReviews] = useState([]);
  const [reviewsRaw, setReviewsRaw] = useState([]);
  const [isCarouselReady, setIsCarouselReady] = useState(false);

  useEffect(() => {
    getReviews();
  }, []);

  useEffect(() => {
    if (reviewsRaw.length > 0) {
      convertReviews();
    }
  }, [reviewsRaw]);

  const getReviews = () => {
    request('/getReviews').then(response => {
      setReviewsRaw(response.data);
      // Force carousel to re-initialize after data is processed
      setIsCarouselReady(true);
    });
  };

  const convertReviews = () => {
    let processedReviews = [];
    reviewsRaw.forEach(item => {
      let i = 0;
      let object = {};
      item.text.split('\n').forEach(text => {
        // First three lines are Date, From and To
        // Then there should be two consecutive /n/n - second one is <hr />
        // Then the review itself
        i++;

        object.customerName = item.customerName;
        object.id = item.id;
        object.review = item.review;

        switch (i) {
          case 1:
            object.date = text;
            break;
          case 2:
            object.from = text;
            break;
          case 3:
            object.to = text;
            break;
          case 5:
            object.text = text;
            break;
          default:
            break;
        }
      });

      processedReviews.push(object);
    });

    setReviews(processedReviews);
  };

  return (
    <div className="homepage__reviews">
      <div className="reviews-header">
        <h2 className="text-center">Recent Reviews</h2>
      </div>
      
      <div className="container-lg position-relative px-0">
        <a 
          href="https://www.trustpilot.com/review/pickuphungary.com" 
          rel="noopener noreferrer" 
          target="_blank"
          className="trustpilot-link"
        >
          <img 
            src={reviewsImg}
            className="reviews-img"
            alt="Reviews of Pickup Hungary"
          />
        </a>

        {isCarouselReady && (
          <Carousel 
            key="reviews-carousel"
            responsive={responsive}
            containerClass="carousel-container"
            itemClass="carousel-item-padding-40-px"
            infinite={true}
          >
            {reviews.map((item, key) => (
              <div key={key} className="react-multi-carousel-item">
                <div className="review-card">
                  <div className="card-body">
                    <h5 className="card-title">{item.customerName}'s Review</h5>
                    <div className="card-text">
                      <span className="d-block">
                        {item.date}
                      </span>
                      <span className="d-block">
                        {item.from}
                      </span>
                      <span className="d-block">
                        {item.to}
                      </span>
                      <hr />
                      <span className="d-block">
                        <TruncateComponent length="300">
                          {item.text}
                        </TruncateComponent>
                      </span>
                    </div>

                    <div className="review-stars">
                      {Array.from(Array(item.review).keys()).map((_, i) => (
                        <i key={i} className="fa fa-duotone fa-star"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  );
};

export default ReviewsComponent;
